//core
import { createSelector } from "@reduxjs/toolkit";

//helpers
import { getTrackingLinkFormData } from "../../../helpers/getTrackingLinkFormData";

//store
import { RootState } from "../../index";

// state
const trackersSelector = (state: RootState) => state.admin.trackers;

const trackersListSelector = (state: RootState) => state.admin.trackers.list;
const trackersListDataSelector = (state: RootState) => state.admin.trackers.list.data;
const trackersListErrorSelector = (state: RootState) => state.admin.trackers.list.error;
const trackersListFetchingSelector = (state: RootState) => state.admin.trackers.list.isFetching;

const trackersArchivedListDataSelector = (state: RootState) => state.admin.trackers.archivedList.data;
const trackersArchivedListErrorSelector = (state: RootState) => state.admin.trackers.archivedList.error;
const trackersArchivedListFetchingSelector = (state: RootState) => state.admin.trackers.archivedList.isFetching;

const trackerDetailsDataSelector = (state: RootState) => state.admin.trackers.tracker.data;
const trackerDetailsErrorSelector = (state: RootState) => state.admin.trackers.tracker.error;
const trackerDetailsFetchingSelector = (state: RootState) => state.admin.trackers.tracker.isFetching;

const trackerEditNameSelector = (state: RootState) => state.admin.trackers.updateTracker.data;
const trackerEditNameErrorSelector = (state: RootState) => state.admin.trackers.updateTracker.error;
const trackerEditNameFetchingSelector = (state: RootState) => state.admin.trackers.updateTracker.isFetching;

const trackerCreateSelector = (state: RootState) => state.admin.trackers.create.data;
const trackerCreateErrorSelector = (state: RootState) => state.admin.trackers.create.error;
const trackerCreateFetchingSelector = (state: RootState) => state.admin.trackers.create.isFetching;

const trackerDefaultConditionSelector = (state: RootState) => state.admin.trackers.defaultCondition.data;
const trackerDefaultConditionErrorSelector = (state: RootState) => state.admin.trackers.defaultCondition.error;
const trackerDefaultConditionFetchingSelector = (state: RootState) => state.admin.trackers.defaultCondition.isFetching;

const archiveTrackerSelector = (state: RootState) => state.admin.trackers.archiveTracker.data;
const archiveTrackerErrorSelector = (state: RootState) => state.admin.trackers.archiveTracker.error;
const archiveTrackerFetchingSelector = (state: RootState) => state.admin.trackers.archiveTracker.isFetching;

const unArchiveTrackerSelector = (state: RootState) => state.admin.trackers.unArchiveTracker.data;
const unArchiveTrackerErrorSelector = (state: RootState) => state.admin.trackers.unArchiveTracker.error;
const unArchiveTrackerFetchingSelector = (state: RootState) => state.admin.trackers.unArchiveTracker.isFetching;

const trackingLinksFilterDataSelector = (state: RootState) => state.admin.trackers.trackingLinksFilter.data;
const trackingLinksFilterErrorSelector = (state: RootState) => state.admin.trackers.trackingLinksFilter.error;
const trackingLinksFilterFetchingSelector = (state: RootState) => state.admin.trackers.trackingLinksFilter.isFetching;

const trackerCreativesListDataSelector = (state: RootState) => state.admin.trackers.trackerCreativesList.data;
const trackerCreativesListErrorSelector = (state: RootState) => state.admin.trackers.trackerCreativesList.error;
const trackerCreativesListFetchingSelector = (state: RootState) => state.admin.trackers.trackerCreativesList.isFetching;

const trackerCreativesMyListDataSelector = (state: RootState) => state.admin.trackers.trackerCreativesMyList.data;
const trackerCreativesMyListErrorSelector = (state: RootState) => state.admin.trackers.trackerCreativesMyList.error;
const trackerCreativesMyListFetchingSelector = (state: RootState) => state.admin.trackers.trackerCreativesMyList.isFetching;

//selectors
export const selectTrackers = createSelector(trackersSelector, (trackers) => trackers);

export const selectList = createSelector(trackersListSelector, (list) => list);
export const selectListData = createSelector(trackersListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item) => {
      if (item.name === 'description') {
        return { ...item, type: 'trackerName' };
      }
      if (item.name === 'nameOfTransaction') {
        return { ...item, type: 'trackerDealName' };
      }
      if (item.name === 'promocodes') {
        return { ...item, type: 'mediumArrayOfStrings' };
      }
      if (item.name === 'is_blocked') {
        return { ...item, type: 'blockedStatus' };
      }
      if (item.name === 'is_trusted') {
        return { ...item, type: 'badge' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data
  }
});
export const selectListDataColumnsSort = createSelector(trackersListDataSelector, (data) => data?.columns.filter((el) => el.sort === true));
export const selectListError = createSelector(trackersListErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(trackersListFetchingSelector, (isFetching) => isFetching);

export const selectArchivedListData = createSelector(trackersArchivedListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item) => {
      if (item.name === 'id') {
        return { ...item, archived: true };
      }

      if (item.name === 'description') {
        return { ...item, type: 'trackerName' };
      }

      if (item.name === 'nameOfTransaction') {
        return { ...item, type: 'trackerDealName' };
      }
      if (item.name === 'is_blocked') {
        return { ...item, type: 'blockedStatus' };
      }
      if (item.name === 'is_trusted') {
        return { ...item, type: 'badge' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data
  }
});
export const selectArchivedListError = createSelector(trackersArchivedListErrorSelector, (error) => error);
export const selectArchivedListIsFetching = createSelector(trackersArchivedListFetchingSelector, (isFetching) => isFetching);

export const selectTrackerData = createSelector(trackerDetailsDataSelector, (data) => data);
export const selectTrackerError = createSelector(trackerDetailsErrorSelector, (error) => error);
export const selectTrackerIsFetching = createSelector(trackerDetailsFetchingSelector, (isFetching) => isFetching);

export const selectEditNameData = createSelector(trackerEditNameSelector, (data) => data);
export const selectEditNameError = createSelector(trackerEditNameErrorSelector, (error) => error);
export const selectEditNameIsFetching = createSelector(trackerEditNameFetchingSelector, (isFetching) => isFetching);

export const selectCreateData = createSelector(trackerCreateSelector, (data) => data);
export const selectCreateError = createSelector(trackerCreateErrorSelector, (error) => error);
export const selectCreateIsFetching = createSelector(trackerCreateFetchingSelector, (isFetching) => isFetching);

export const selectDefaultConditionData = createSelector(trackerDefaultConditionSelector, (data) => data);
export const selectDefaultConditionError = createSelector(trackerDefaultConditionErrorSelector, (error) => error);
export const selectDefaultConditionIsFetching = createSelector(trackerDefaultConditionFetchingSelector, (isFetching) => isFetching);

export const selectArchiveTrackerSelectorData = createSelector(archiveTrackerSelector, (data) => data);
export const selectArchiveTrackerSelectorError = createSelector(archiveTrackerErrorSelector, (error) => error);
export const selectArchiveTrackerSelectorIsFetching = createSelector(archiveTrackerFetchingSelector, (isFetching) => isFetching);

export const selectUnArchiveTrackerSelectorData = createSelector(unArchiveTrackerSelector, (data) => data);
export const selectUnArchiveTrackerSelectorError = createSelector(unArchiveTrackerErrorSelector, (error) => error);
export const selectUnArchiveTrackerSelectorIsFetching = createSelector(unArchiveTrackerFetchingSelector, (isFetching) => isFetching);

export const selectTrackingLinksFilterData = createSelector(trackingLinksFilterDataSelector, (data) => data);
export const selectTrackingLinksFilterError = createSelector(trackingLinksFilterErrorSelector, (error) => error);
export const selectTrackingLinksFilterIsFetching = createSelector(trackingLinksFilterFetchingSelector, (isFetching) => isFetching);

export const selectTrackerCreativesListData = createSelector(trackerCreativesListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item) => {
      if (item.name === 'id') {
        return { ...item, type: 'string' };
      }
      if (item.name === 'brands') {
        return { ...item, type: 'brandsArray' };
      }
      if (item.name === 'geo') {
        return { ...item, type: 'countriesArray' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data
  }
});
export const selectTrackerCreativesListError = createSelector(trackerCreativesListErrorSelector, (error) => error);
export const selectTrackerCreativesListIsFetching = createSelector(trackerCreativesListFetchingSelector, (isFetching) => isFetching);

export const selectTrackerCreativesMyListData = createSelector(trackerCreativesMyListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item) => {
      if (item.name === 'id') {
        return { ...item, type: 'string' };
      }
      if (item.name === 'brands') {
        return { ...item, type: 'brandsArray' };
      }
      if (item.name === 'geo') {
        return { ...item, type: 'countriesArray' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data
  }
});
export const selectTrackerCreativesMyListError = createSelector(trackerCreativesMyListErrorSelector, (error) => error);
export const selectTrackerCreativesMyListIsFetching = createSelector(trackerCreativesMyListFetchingSelector, (isFetching) => isFetching);


const trackerCreateTrackingLinkDataSelector = (state: RootState) => state.admin.trackers.createTrackingLink.data;
const trackerCreateTrackingLinkErrorSelector = (state: RootState) => state.admin.trackers.createTrackingLink.error;
const trackerCreateTrackingLinkFetchingSelector = (state: RootState) => state.admin.trackers.createTrackingLink.isFetching;

export const selectCreateTrackingLinkData = createSelector(trackerCreateTrackingLinkDataSelector, (data) => data);

const trackingLinkV1DataSelector = (state: RootState) => state.admin.trackers.trackingLinkV1.data;
const trackingLinkV1ErrorSelector = (state: RootState) => state.admin.trackers.trackingLinkV1.error;
const trackingLinkV1FetchingSelector = (state: RootState) => state.admin.trackers.trackingLinkV1.isFetching;

const trackingLinkFormOptionsDataSelector = (state: RootState) => state.admin.trackers.trackingLinkFormOptions.data;
const trackingLinkFormOptionsErrorSelector = (state: RootState) => state.admin.trackers.trackingLinkFormOptions.error;
const trackingLinkFormOptionsFetchingSelector = (state: RootState) => state.admin.trackers.trackingLinkFormOptions.isFetching;

export const selectTrackingLinkV1Error = createSelector(trackingLinkV1ErrorSelector, (error) => error);
export const selectTrackingLinkV1IsFetching = createSelector(trackingLinkV1FetchingSelector, (isFetching) => isFetching);
export const selectTrackingLinkFormOptionsError = createSelector(trackingLinkFormOptionsErrorSelector, (error) => error);
export const selectTrackingLinkFormOptionsIsFetching = createSelector(trackingLinkFormOptionsFetchingSelector, (isFetching) => isFetching);

export const selectCreateTrackingLinkV1Data = createSelector(
  trackingLinkFormOptionsDataSelector,
  (options) => !!options ? getTrackingLinkFormData(options) : null
);

export const selectEditTrackingLinkV1Data = createSelector(
  trackingLinkFormOptionsDataSelector,
  trackingLinkV1DataSelector,
  (options, link) => !!options && !!link ? getTrackingLinkFormData(options, link) : null
);
export const selectCreateTrackingLinkError = createSelector(trackerCreateTrackingLinkErrorSelector, (error) => error);
export const selectCreateTrackingLinkIsFetching = createSelector(trackerCreateTrackingLinkFetchingSelector, (isFetching) => isFetching);

const trackerSaveTrackingLinkDataSelector = (state: RootState) => state.admin.trackers.saveTrackingLink.data;
const trackerSaveTrackingLinkErrorSelector = (state: RootState) => state.admin.trackers.saveTrackingLink.error;
const trackerSaveTrackingLinkFetchingSelector = (state: RootState) => state.admin.trackers.saveTrackingLink.isFetching;

export const selectSaveTrackingLinkData = createSelector(trackerSaveTrackingLinkDataSelector, (data) => data);
export const selectSaveTrackingLinkError = createSelector(trackerSaveTrackingLinkErrorSelector, (error) => error);
export const selectSaveTrackingLinkIsFetching = createSelector(trackerSaveTrackingLinkFetchingSelector, (isFetching) => isFetching);

const trackerDeleteTrackingLinkDataSelector = (state: RootState) => state.admin.trackers.deleteTrackingLink.data;
const trackerDeleteTrackingLinkErrorSelector = (state: RootState) => state.admin.trackers.deleteTrackingLink.error;
const trackerDeleteTrackingLinkFetchingSelector = (state: RootState) => state.admin.trackers.deleteTrackingLink.isFetching;

export const selectDeleteTrackingLinkData = createSelector(trackerDeleteTrackingLinkDataSelector, (data) => data);
export const selectDeleteTrackingLinkError = createSelector(trackerDeleteTrackingLinkErrorSelector, (error) => error);
export const selectDeleteTrackingLinkIsFetching = createSelector(trackerDeleteTrackingLinkFetchingSelector, (isFetching) => isFetching);

const trackerEditTrackingLinkDataSelector = (state: RootState) => state.admin.trackers.editTrackingLink.data;
const trackerEditTrackingLinkErrorSelector = (state: RootState) => state.admin.trackers.editTrackingLink.error;
const trackerEditTrackingLinkFetchingSelector = (state: RootState) => state.admin.trackers.editTrackingLink.isFetching;

export const selectEditTrackingLinkData = createSelector(trackerEditTrackingLinkDataSelector, (data) => data);
export const selectEditTrackingLinkError = createSelector(trackerEditTrackingLinkErrorSelector, (error) => error);
export const selectEditTrackingLinkIsFetching = createSelector(trackerEditTrackingLinkFetchingSelector, (isFetching) => isFetching);

const trackerUpdateTrackingLinkDataSelector = (state: RootState) => state.admin.trackers.updateTrackingLink.data;
const trackerUpdateTrackingLinkErrorSelector = (state: RootState) => state.admin.trackers.updateTrackingLink.error;
const trackerUpdateTrackingLinkFetchingSelector = (state: RootState) => state.admin.trackers.updateTrackingLink.isFetching;

export const selectUpdateTrackingLinkData = createSelector(trackerUpdateTrackingLinkDataSelector, (data) => data);
export const selectUpdateTrackingLinkError = createSelector(trackerUpdateTrackingLinkErrorSelector, (error) => error);
export const selectUpdateTrackingLinkIsFetching = createSelector(trackerUpdateTrackingLinkFetchingSelector, (isFetching) => isFetching);



//conditions
const conditionsDataSelector = (state: RootState) => state.admin.trackers.conditions.data;
const conditionsErrorSelector = (state: RootState) => state.admin.trackers.conditions.error;
const conditionsFetchingSelector = (state: RootState) => state.admin.trackers.conditions.isFetching;

export const selectConditionsData = createSelector(conditionsDataSelector, (data) => {
  if (!!data) {
    const conditions = data.conditions.all_condition.reduce((acc: any[], item: any) => {
      acc.push({
        ...item,
        title: `${item.title}`
      })
      return acc;
    },[]);

    const selectedCondition = conditions.filter((item: any) => {
      return item.id === data.affiliate.condition_id;
    });

    return {
      ...data,
      conditions: {
        all_condition: conditions,
      },
      selectedCondition: !!selectedCondition.length ? selectedCondition[0] : {
        id: data.affiliate.condition_id,
        title: `${data.affiliate.condition_name}`,
        type_of_transaction: '',
      },
    }
  } else {
    return data;
  }
});
export const selectConditionsError = createSelector(conditionsErrorSelector, (error) => error);
export const selectConditionsIsFetching = createSelector(conditionsFetchingSelector, (isFetching) => isFetching);

// Current Tracker
const currentTrackerDataSelector = (state: RootState) => state.admin.trackers.currentTracker.data;
const currentTrackerErrorSelector = (state: RootState) => state.admin.trackers.currentTracker.error;
const currentTrackerFetchingSelector = (state: RootState) => state.admin.trackers.currentTracker.isFetching;

export const selectCurrentTrackerData = createSelector(currentTrackerDataSelector, (data) => {
  if (!!data) {
    return {
      ...data,
      conditions: {
        all_condition: data.conditions.all_condition.reduce((acc: any[], item: any) => {
          acc.push({
            ...item,
            title: `deal id: ${item.id}; ${item.title}`
          });
          return acc;
        }, [])
      },
    }
  } else {
    return data;
  }
});
export const selectCurrentTrackerError = createSelector(currentTrackerErrorSelector, (error) => error);
export const selectCurrentTrackerIsFetching = createSelector(currentTrackerFetchingSelector, (isFetching) => isFetching);

// Update Tracker Deal
const updateTrackerDealDataSelector = (state: RootState) => state.admin.trackers.updateTrackerDeal.data;
const updateTrackerDealErrorSelector = (state: RootState) => state.admin.trackers.updateTrackerDeal.error;
const updateTrackerDealFetchingSelector = (state: RootState) => state.admin.trackers.updateTrackerDeal.isFetching;

export const selectUpdateTrackerDealData = createSelector(updateTrackerDealDataSelector, (data) => data);
export const selectUpdateTrackerDealError = createSelector(updateTrackerDealErrorSelector, (error) => error);
export const selectUpdateTrackerDealIsFetching = createSelector(updateTrackerDealFetchingSelector, (isFetching) => isFetching);

// Delete History Row
const deleteHistoryRowDataSelector = (state: RootState) => state.admin.trackers.deleteHistoryRow.data;
const deleteHistoryRowErrorSelector = (state: RootState) => state.admin.trackers.deleteHistoryRow.error;
const deleteHistoryRowFetchingSelector = (state: RootState) => state.admin.trackers.deleteHistoryRow.isFetching;

export const selectDeleteHistoryRowData = createSelector(deleteHistoryRowDataSelector, (data) => data);
export const selectDeleteHistoryRowError = createSelector(deleteHistoryRowErrorSelector, (error) => error);
export const selectDeleteHistoryRowIsFetching = createSelector(deleteHistoryRowFetchingSelector, (isFetching) => isFetching);

// Delete History Row
const editHistoryRowDataSelector = (state: RootState) => state.admin.trackers.editHistoryRow.data;
const editHistoryRowErrorSelector = (state: RootState) => state.admin.trackers.editHistoryRow.error;
const editHistoryRowFetchingSelector = (state: RootState) => state.admin.trackers.editHistoryRow.isFetching;

export const selectEditHistoryRowData = createSelector(editHistoryRowDataSelector, (data) => {
  if (!!data) {
    return {
      ...data,
      conditions: {
        all_condition: data.conditions.all_condition.reduce((acc: any[], item: any) => {
          acc.push({
            ...item,
            title: `deal id: ${item.id}; ${item.title}`
          });
          return acc;
        }, [])
      },
    }
  } else {
    return data;
  }
});
export const selectEditHistoryRowError = createSelector(editHistoryRowErrorSelector, (error) => error);
export const selectEditHistoryRowIsFetching = createSelector(editHistoryRowFetchingSelector, (isFetching) => isFetching);

// Update History Row
const updateHistoryRowDataSelector = (state: RootState) => state.admin.trackers.updateHistoryRow.data;
const updateHistoryRowErrorSelector = (state: RootState) => state.admin.trackers.updateHistoryRow.error;
const updateHistoryRowFetchingSelector = (state: RootState) => state.admin.trackers.updateHistoryRow.isFetching;

export const selectUpdateHistoryRowData = createSelector(updateHistoryRowDataSelector, (data) => data);
export const selectUpdateHistoryRowError = createSelector(updateHistoryRowErrorSelector, (error) => error);
export const selectUpdateHistoryRowIsFetching = createSelector(updateHistoryRowFetchingSelector, (isFetching) => isFetching);

// Settings
const settingsDataSelector = (state: RootState) => state.admin.trackers.settings.data;
const settingsErrorSelector = (state: RootState) => state.admin.trackers.settings.error;
const settingsFetchingSelector = (state: RootState) => state.admin.trackers.settings.isFetching;

export const selectSettingsData = createSelector(settingsDataSelector, (data) => {
  if (!!data) {
    return {
      ...data,
      conditions: {
        all_condition: data.conditions.all_condition.reduce((acc: any[], item: any) => {
          acc.push({
            ...item,
            title: `${item.id} - ${item.title}`
          })
          return acc
        }, [])
      }
    }
  } else {
    return data
  }
});
export const selectSettingsError = createSelector(settingsErrorSelector, (error) => error);
export const selectSettingsIsFetching = createSelector(settingsFetchingSelector, (isFetching) => isFetching);

// Trackers Count
const trackersCountDataSelector = (state: RootState) => state.admin.trackers.count.data;
const trackersCountErrorSelector = (state: RootState) => state.admin.trackers.count.error;
const trackersCountFetchingSelector = (state: RootState) => state.admin.trackers.count.isFetching;

export const selectTrackersCountData = createSelector(trackersCountDataSelector, (data) => data);
export const selectTrackersCountError = createSelector(trackersCountErrorSelector, (error) => error);
export const selectTrackersCountIsFetching = createSelector(trackersCountFetchingSelector, (isFetching) => isFetching);

// Update Tracker
const updateTrackerDataSelector = (state: RootState) => state.admin.trackers.updateTracker.data;
const updateTrackerErrorSelector = (state: RootState) => state.admin.trackers.updateTracker.error;
const updateTrackerFetchingSelector = (state: RootState) => state.admin.trackers.updateTracker.isFetching;

export const selectUpdateTrackerData = createSelector(updateTrackerDataSelector, (data) => data);
export const selectUpdateTrackerError = createSelector(updateTrackerErrorSelector, (error) => error);
export const selectUpdateTrackerIsFetching = createSelector(updateTrackerFetchingSelector, (isFetching) => isFetching);

// Save promocode
const trackerSavePromocodeDataSelector = (state: RootState) => state.admin.trackers.savePromocode.data;
const trackerSavePromocodeErrorSelector = (state: RootState) => state.admin.trackers.savePromocode.error;
const trackerSavePromocodeFetchingSelector = (state: RootState) => state.admin.trackers.savePromocode.isFetching;

export const selectSavePromocodeData = createSelector(trackerSavePromocodeDataSelector, (data) => data);
export const selectSavePromocodeError = createSelector(trackerSavePromocodeErrorSelector, (error) => error);
export const selectSavePromocodeIsFetching = createSelector(trackerSavePromocodeFetchingSelector, (isFetching) => isFetching);

// Get promocode list
const trackerGetPromocodeListDataSelector = (state: RootState) => state.admin.trackers.getPromocode.data;
const trackerGetPromocodeListErrorSelector = (state: RootState) => state.admin.trackers.getPromocode.error;
const trackerGetPromocodeListFetchingSelector = (state: RootState) => state.admin.trackers.getPromocode.isFetching;

export const selectPromocodeListData = createSelector(trackerGetPromocodeListDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item:any) => {
      if (item.name === 'promocode') {
        return { ...item, type: 'boldText' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data
  }
});
export const selectPromocodeListDataColumnsSort = createSelector(trackerGetPromocodeListDataSelector, (data) => data?.columns?.filter((el:any) => el.sort === true));
export const selectPromocodeListError = createSelector(trackerGetPromocodeListErrorSelector, (error) => error);
export const selectPromocodeListIsFetching = createSelector(trackerGetPromocodeListFetchingSelector, (isFetching) => isFetching);


// Create promocode
const trackerCreatePromocodeDataSelector = (state: RootState) => state.admin.trackers.createPromocode.data;
const trackerCreatePromocodeErrorSelector = (state: RootState) => state.admin.trackers.createPromocode.error;
const trackerCreatePromocodeFetchingSelector = (state: RootState) => state.admin.trackers.createPromocode.isFetching;

export const selectCreatePromocodeData = createSelector(trackerCreatePromocodeDataSelector, (data) => data);
export const selectCreatePromocodeError = createSelector(trackerCreatePromocodeErrorSelector, (error) => error);
export const selectCreatePromocodeIsFetching = createSelector(trackerCreatePromocodeFetchingSelector, (isFetching) => isFetching);

// Delete promocode
const trackerDeletePromocodeDataSelector = (state: RootState) => state.admin.trackers.deletePromocode.data;
const trackerDeletePromocodeErrorSelector = (state: RootState) => state.admin.trackers.deletePromocode.error;
const trackerDeletePromocodeFetchingSelector = (state: RootState) => state.admin.trackers.deletePromocode.isFetching;

export const selectDeletePromocodeData = createSelector(trackerDeletePromocodeDataSelector, (data) => data);
export const selectDeletePromocodeError = createSelector(trackerDeletePromocodeErrorSelector, (error) => error);
export const selectDeletePromocodeIsFetching = createSelector(trackerDeletePromocodeFetchingSelector, (isFetching) => isFetching);


//Additional settings trackers
const additionalSettingsDataSelector = (state: RootState) => state.admin.trackers.additionalSettings.data;
const additionalSettingsErrorSelector = (state: RootState) => state.admin.trackers.additionalSettings.error;
const additionalSettingsFetchingSelector = (state: RootState) => state.admin.trackers.additionalSettings.isFetching;

export const selectAdditionalSettingsData = createSelector(additionalSettingsDataSelector, (data) => data);
export const selectAdditionalSettingsError = createSelector(additionalSettingsErrorSelector, (error) => error);
export const selectAdditionalSettingsIsFetching = createSelector(additionalSettingsFetchingSelector, (isFetching) => isFetching);

//Additional settings update trackers
const additionalSettingsUpdateDataSelector = (state: RootState) => state.admin.trackers.updateAdditionalSettings.data;
const additionalSettingsUpdateErrorSelector = (state: RootState) => state.admin.trackers.updateAdditionalSettings.error;
const additionalSettingsUpdateFetchingSelector = (state: RootState) => state.admin.trackers.updateAdditionalSettings.isFetching;

export const selectAdditionalSettingsUpdateData = createSelector(additionalSettingsUpdateDataSelector, (data) => data);
export const selectAdditionalSettingsUpdateError = createSelector(additionalSettingsUpdateErrorSelector, (error) => error);
export const selectAdditionalSettingsUpdateIsFetching = createSelector(additionalSettingsUpdateFetchingSelector, (isFetching) => isFetching);


// Block Tracker
const blockTrackerDataSelector = (state: RootState) => state.admin.trackers.blockTracker.data;
const blockTrackerErrorSelector = (state: RootState) => state.admin.trackers.blockTracker.error;
const blockTrackerFetchingSelector = (state: RootState) => state.admin.trackers.blockTracker.isFetching;

export const selectBlockTrackerData = createSelector(blockTrackerDataSelector, (data) => data);
export const selectBlockTrackerError = createSelector(blockTrackerErrorSelector, (error) => error);
export const selectBlockTrackerIsFetching = createSelector(blockTrackerFetchingSelector, (isFetching) => isFetching);


//Additional settings logs trackers
const additionalSettingsLogsDataSelector = (state: RootState) => state.admin.trackers.additionalSettingsLogs.data;
const additionalSettingsLogsErrorSelector = (state: RootState) => state.admin.trackers.additionalSettingsLogs.error;
const additionalSettingsLogsFetchingSelector = (state: RootState) => state.admin.trackers.additionalSettingsLogs.isFetching;

export const selectAdditionalSettingsLogsData = createSelector(additionalSettingsLogsDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item:any) => {
      if (item.name === 'changedAt') {
        return { ...item, type: 'fulldatetime' };
      }
      if (item.name === 'settingType') {
        return { ...item, type: 'stringWithPrefix', prefix: 'admin.partners.trackers.additional_settings.filters.' };
      }
      if (item.name === 'changes') {
        return { ...item, type: 'AddSettingsLogsItem' };
      }

      if (item.name === 'changedByUserName') {
        return { ...item, type: 'tooltipText' };
      }

      return item;
    });

    return { ...data, columns: columns };
  } else {
    return data
  }
});
export const selectAdditionalSettingsLogsError = createSelector(additionalSettingsLogsErrorSelector, (error) => error);
export const selectAdditionalSettingsLogsIsFetching = createSelector(additionalSettingsLogsFetchingSelector, (isFetching) => isFetching);


//Additional settings types trackers
const additionalSettingsTypesDataSelector = (state: RootState) => state.admin.trackers.additionalSettingsTypes.data;
const additionalSettingsTypesErrorSelector = (state: RootState) => state.admin.trackers.additionalSettingsTypes.error;
const additionalSettingsTypesFetchingSelector = (state: RootState) => state.admin.trackers.additionalSettingsTypes.isFetching;

export const selectAdditionalSettingsTypesData = createSelector(additionalSettingsTypesDataSelector, (data) => data);
export const selectAdditionalSettingsTypesError = createSelector(additionalSettingsTypesErrorSelector, (error) => error);
export const selectAdditionalSettingsTypesIsFetching = createSelector(additionalSettingsTypesFetchingSelector, (isFetching) => isFetching);

// Update Trackers Deal
const updateTrackersDealDataSelector = (state: RootState) => state.admin.trackers.updateTrackersDeal.data;
const updateTrackersDealErrorSelector = (state: RootState) => state.admin.trackers.updateTrackersDeal.error;
const updateTrackersDealFetchingSelector = (state: RootState) => state.admin.trackers.updateTrackersDeal.isFetching;

export const selectUpdateTrackersDealData = createSelector(updateTrackersDealDataSelector, (data) => data);
export const selectUpdateTrackersDealError = createSelector(updateTrackersDealErrorSelector, (error) => error);
export const selectUpdateTrackersDealIsFetching = createSelector(updateTrackersDealFetchingSelector, (isFetching) => isFetching);